import type { CorrectedWord, FillLogsTone } from '../model/fill-logs-text';

export const TONE_BAR: Record<FillLogsTone, string> = {
  filled: 'border-l-change-added-border',
  corrected: 'border-l-change-fixed-border',
};

export const TONE_TINT: Record<FillLogsTone, string> = {
  filled: 'bg-change-added',
  corrected: 'bg-change-fixed',
};

export function toneSaid(tone: FillLogsTone, correctedWord: CorrectedWord): string {
  return `${tone === 'filled' ? 'preenchido' : correctedWord} nesta resposta`;
}

export const READING_BUTTON =
  'w-full text-left hover:bg-gray-09 focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-[var(--theme-secondary-ink)]';
